import React from "react";
import ReactDOM from "react-dom/client";
import "./index.less";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { PostHogProvider } from "posthog-js/react";
import { keysToSnake } from "./shared/global";

const SHOULD_SEND_POSTHOG =
  process.env.REACT_APP_ENV === "LIVE" ||
  process.env.REACT_APP_FORCE_SEND_POSTHOG === "true";

async function unregister() {
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (let registration of registrations) {
      await registration.unregister();
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    {SHOULD_SEND_POSTHOG ? (
      <PostHogProvider
        apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY ?? ""}
        options={keysToSnake({
          apiHost: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        })}
      >
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

unregister().then();

reportWebVitals();
